import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { IndexCompanyComponent } from '../index-company/index-company.component';
import { IndexNavGridComponent } from '../../components/index-nav-grid/index-nav-grid.component';
import { CoreService } from '../../../../services/core.service';
import { SocialAistateListService } from '../../../../services/social-ai-state-list.service';
import { FormsModule } from '@angular/forms';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { CreateFeedComponent } from '../../create/create-feed/create-feed.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';

@Component({
  selector: 'app-index-feeds',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonToggleModule,
    SectionGridComponent,
    IndexCompanyComponent,
    IndexNavGridComponent,
    FormsModule,
    MatSortModule,
    CreateFeedComponent,
    FooterGridComponent
  ],
  templateUrl: './index-feeds.component.html',
  styleUrl: './index-feeds.component.scss'
})
export class IndexFeedsComponent {

  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['id', 'title', 'feed', 'page', 'template', 'status', 'created_at', 'total_published_posts', 'actions'];
  searchValue: string = "";
  companyID: number = 0;
  totalItems = 0;
  pageSize = 12;
  isLoading = true;
  hasLoaded = false;
  showFeedModal = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  sortField: string = 'feed';
  sortDirection: string = 'asc';

  constructor(
    private coreService: CoreService,
    private listState: SocialAistateListService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.companyID = params['company'];
    });

    if (this.listState.searchValue) {
      this.searchValue = this.listState.searchValue;
      console.log(this.listState.searchValue)
    }
    this.loadFeeds(this.listState.page);

  }

  loadFeeds(page: number) {
    this.listState.page = page;
    this.isLoading = true;

    this.coreService
      .getData('/manageAccount/post-categories/index', {
        companyID: this.companyID,
        page,
        keyword: this.searchValue,
        sort: this.sortField,
        direction: this.sortDirection
      })
      .subscribe({
        next: (res: any) => {
          console.log(res.data);
          this.dataSource.data = res.data || [];
          this.totalItems = res.total;
          this.pageSize = res.per_page;
          this.hasLoaded = true;

          if (this.paginator) {
            this.paginator.pageIndex = res.current_page - 1;
            this.paginator.length = res.total;
            this.paginator.pageSize = res.per_page;
          }
        },
        error: (err) => {
          console.error('Load error:', err);
          this.dataSource.data = [];
          this.hasLoaded = true;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  editFeed(feed: any) {
    console.log('Edit page:', feed);
  }

  deleteFeed(feed: any) {
    console.log('Delete page:', feed);
  }

  addNewFeed() {
    console.log('Add new page clicked');
  }

  onSearchSubmit(value: string) {
    this.searchValue = value.trim();
    this.listState.searchValue = this.searchValue; //save filter
    this.loadFeeds(1);
  }

  clearSearch() {
    this.searchValue = "";
    this.listState.searchValue = ""; //clear state too
    this.loadFeeds(1);
  }

  onPageChange(event: any) {
    const newPage = event.pageIndex + 1;
    this.loadFeeds(newPage);
  }

  onSortChange(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || 'asc';
    this.loadFeeds(1);
  }

  onFeedCreated(data: any) {
    this.showFeedModal = false;
    this.loadFeeds(1);
  }
}
